import * as React from "react";
import FtUnderMaintenance from "../ftMaintenance/ftUnderMaintenance";
import { Idevice } from "../../../types/device";
import DeviceContext from "../../../service/indentifyDevice";
import FtContainerDesk from "../ftContainer/ftContainerDesk";
import FtContainerTab from "../ftContainer/ftContainerTab";
import FtContainerMob from "../ftContainer/ftContainerMob";
import FtPayInFormWrapper from "./ftPayInFormWrapper";
import { AEqFundBankDetils, AFTCommFetchPayInURL } from "../../../service/fundTransfer/fundTransferApiService";
import { IftPayInBankListDetails, IftPayInBankDetails } from "../../../types/components/fundTransfer/ftTypes";
import { useQuery } from "../../../service/urlHelper";
import { useHistory } from "react-router-dom";
import ftURLConfig from "../../../../config/toc/ftURLConfig";
import { SLoader } from "../../../generic/loader";
import LoginService from "../../../service/login/loginService";
import NoDataContainer from "../../../generic/noDataContainer";

export enum EFtEquityFormFields {
	AMOUNT = "amount",
	LEDGER = "ledger",
	BANK = "bank",
	MODE = "mode",
	UPI = "upi"
}

interface IFtPayInContProps {}

const FtPayInCont: React.FunctionComponent<IFtPayInContProps> = (props) => {
	// const LoginService.pToken: jwtToken | null = parsedToken();
	const deviceState: Idevice = DeviceContext();
	const query = useQuery(),
		history = useHistory();

	const [commPayinURL, setCommPayinURL] = React.useState<string>();
	const [eqBankDetails, setEqBankDetails] = React.useState<IftPayInBankListDetails>();

	const eqFundBankDetilsRes = (res: any) => {
		if (res.data) {
			let bnkDetails: IftPayInBankListDetails = res.data;

			if (bnkDetails.bnkAcs.length > 0) {
				bnkDetails.bnkAcs[0].isPrimary = true; //if latest flag is not available for any of the bank set first bank as primary bank
			}
			bnkDetails.bnkAcs.map((val: IftPayInBankDetails, index: number) => {
				if (val.latest && index > 0) {
					bnkDetails.bnkAcs[0].isPrimary = false;
					bnkDetails.bnkAcs[index].isPrimary = true;
				}
				bnkDetails.bnkAcs[index].upiList = [];

				return true;
			});

			setEqBankDetails(bnkDetails);
			if (LoginService.pToken && LoginService.pToken.accType !== "COMEQ") {
				// bnkDetails.payinMntFlg = true;
				setInst(
					bnkDetails.payinMntFlg ? (
						<FtPayInFormWrapper
							data={bnkDetails}
							maintenanceNode={<FtUnderMaintenance payinMaintenance={bnkDetails.payinMaintenance} />}
						/>
					) : (
						<FtPayInFormWrapper data={bnkDetails} />
					)
				);
			} else {
				hdnlPayin();
			}
		} else {
			if (LoginService.pToken && LoginService.pToken.accType !== "COMEQ") {
				setInst(<NoDataContainer txtHeading="Request Timeout" />);
			}
		}
	};
	const getCommPayinURL = (res: any) => {
		if (res.data) {
			setCommPayinURL(res.data.url);
			if (LoginService.pToken && LoginService.pToken.accType !== "COMEQ") {
				setInst(<FtPayInFormWrapper commPayInURL={res.data.url} />);
			} else {
				hdnlPayin();
			}
		}
	};
	function hdnlPayin() {
		if (commPayinURL && eqBankDetails && LoginService.pToken && LoginService.pToken.accType === "COMEQ") {
			// eqBankDetails.payinMntFlg = true;
			if (eqBankDetails.payinMntFlg) {
				// setInst(<FtUnderMaintenance payinMaintenance={eqBankDetails.payinMaintenance} />);
				setInst(
					<FtPayInFormWrapper
						commPayInURL={commPayinURL}
						data={eqBankDetails}
						maintenanceNode={<FtUnderMaintenance payinMaintenance={eqBankDetails.payinMaintenance} />}
					/>
				);
			} else {
				setInst(<FtPayInFormWrapper commPayInURL={commPayinURL} data={eqBankDetails} />);
			}
		}
	}
	function init() {
		if (query.get("status")) {
			window.history.pushState({}, "", window.location.href.split("?")[0]);
			const url: string = ftURLConfig.pageURL.payinStatus + query.get("status");
			history.push(url);
		} else {
			AEqFundBankDetils(eqFundBankDetilsRes);
			AFTCommFetchPayInURL(getCommPayinURL);
		}
		return SLoader(20, "blue");
	}

	function reducer(_prevState: React.ReactNode, newState: React.ReactNode) {
		return newState;
	}
	//selected asset either EQ or CO

	const [inst, setInst] = React.useReducer(reducer, <></>, init);

	React.useEffect(() => {
		hdnlPayin();
		// eslint-disable-next-line
	}, [commPayinURL, eqBankDetails]);

	return (
		<section className="ftSection">
			{deviceState.isDesktop ? (
				<FtContainerDesk instComp={inst} />
			) : deviceState.isTablet ? (
				<FtContainerTab instComp={inst} />
			) : (
				<FtContainerMob instComp={inst} />
			)}
		</section>
	);
};

export default FtPayInCont;
